var map = {
	"./KP101.glb": 79,
	"./Kioskopay.glb": 5326,
	"./Medidor.glb": 9338,
	"./QPMINI.glb": 3484,
	"./World.glb": 6032,
	"./robot_playground.glb": 830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2550;